var map = {
	"./anm-card.png": 1023,
	"./arrow.png": 1024,
	"./arrow.webp": 1025,
	"./asset-1.svg": 1026,
	"./bg-exclusive.webp": 1027,
	"./boost.svg": 1028,
	"./brand-logo-cny.png": 1029,
	"./brand-logo-raya.webp": 1030,
	"./brand-logo.png": 108,
	"./brand-logo.webp": 1031,
	"./btn-black-m.webp": 1032,
	"./btn-blue-m-v2.png": 1033,
	"./btn-blue-m.png": 1034,
	"./btn-blue-m.webp": 1035,
	"./btn-white-m-v2.png": 1036,
	"./btn-white-m.png": 1037,
	"./default-bg.webp": 1038,
	"./deposit.webp": 1039,
	"./drop-more-btn.webp": 1040,
	"./duitnow.svg": 1041,
	"./eeziepay.svg": 1042,
	"./fcl.svg": 1043,
	"./fcl.webp": 1044,
	"./fpx-logo.svg": 1045,
	"./game-blue.png": 1046,
	"./game-img.png": 1047,
	"./game-white.png": 1048,
	"./global-language.svg": 1049,
	"./grabpay.svg": 1050,
	"./ifm-logo.svg": 1051,
	"./ifm-logo.webp": 1052,
	"./modal-bg.jpg": 1053,
	"./number-bg.webp": 1054,
	"./pagcor.svg": 1055,
	"./pagcor.webp": 1056,
	"./pool-bg.webp": 1057,
	"./promo-given.webp": 1058,
	"./side-bar-bg.png": 1059,
	"./spotlight-base.svg": 1060,
	"./spotlight.svg": 1061,
	"./tether.svg": 1062,
	"./title-asset.svg": 1063,
	"./tng.svg": 1064,
	"./winner.webp": 1065,
	"./withdrawal.webp": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;